import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { getMeterReaderById } from '@/lib/api/meter'
import MeterReaderForm from '@/components/forms/meter-reader-form'
import { Header } from '@/components/header'

export const Route = createFileRoute(
  '/_home/meter-connection-settings/meter-reader/edit/$id',
)({
  loader: async ({ params: { id } }) => {
    return { id }
  },
  component: EditMeterReader,
})

function EditMeterReader() {
  const { id } = Route.useLoaderData()
  const meterReaderId = Number(id)
  const { data, isError, isLoading } = useQuery({
    queryKey: ['meterReader'],
    queryFn: () => getMeterReaderById(meterReaderId),
  })

  return (
    <main className="space-y-3 p-3">
      <Header
        subroutes={[
          {
            route: '/meter-connection-settings/meter-reader',
            label: 'Meter Reader Zone',
          },
        ]}
      >
        Edit Meter Reader
      </Header>
      {/*<MeterReaderForm editData={data} /> */}
    </main>
  )
}
